// extracted by mini-css-extract-plugin
module.exports = {"graphsWrapper":"StatisticsColumnChart_graphsWrapper__EpQNF"};